/* Import CSS */
import './admin.scss';


// @todo: Not working as expected. Find out why.
// import { addFilter } from '@wordpress/hooks';

// addFilter(
// 	'editPost.MoreMenu.tools',
// 	'stylist/stylistGutenbergMenuItem',
// 	stylistGutenbergMenuItem ( items ),
// );

// addFilter( 'hookName', 'functionName', callback, priority )


// stylistEditLink - is localized object passed
// from function edit_in_stylist_link in PHP. It contains data we need
// to link "Open page in Stylist" properly.
wp.hooks.addFilter(
    'editPost.MoreMenu.tools',
    'stylist/edit-post/menuTools/openInStylist',
    ( items ) => [ ...items, <span><a href={stylistEditLink.href} class="components-button components-stylist-button components-menu-item__button">Open page in Stylist</a></span> ]
);

! function(t) {
    "use strict";
    t(document).ready(function() {
        t(document).on("click", ".stlst-btn,.stlst-btn-bottom", function() {
            if ("pending" == t("#hidden_post_status").val() || "private" == t("#hidden_post_status").val() || "draft" == t("#hidden_post_status").val() || "publish" == t("#hidden_post_status").val() || undefined == t("#hidden_post_status").val()) {
                var n = t("#sample-permalink").find("a").attr("href"),
                    e = t("#post_ID").val();
                    if(n == 'undefined' || n === undefined){
                        n = t("#sample-permalink").text();
                    }
                    if(n.indexOf("://") != -1){
                        n = n.split("://")[1];
                    }
                n = "admin.php?page=stylist-editor&href=" + encodeURIComponent(n) + "&stlst_id=" + e, t(this).hasClass("stlst-btn-bottom") ? (n = n.split("&stlst_id"), window.open(n[0] + "&stlst_type=" + typenow, "_blank")) : window.open(n, "_blank")
            } else alert("Please save this post as draft or publish.")
        }), 0 == t("body").hasClass("post-type-attachment") && t("#postbox-container-1").length > 0 && (t("#postbox-container-1").prepend("<a class='stlst-btn-bottom'>OR <small>CUSTOMIZE " + typenow + " TEMPLATE</small> <span class='dashicons dashicons-external'></span></a>"), t("#postbox-container-1").prepend("<a class='stlst-btn'><span class='dashicons dashicons-admin-appearance'></span><small>Edit Page -</small> Stylist</a>"))
    })
}(jQuery);


// WEBPACK FOOTER //
// ./dev/admin/index.js